import { TreeItem } from '@dealstack/frontend/shared/components/Tree/utils';
import { ChildrenContainer, ChildWrapper, TreeButton } from './styled';
import { replaceSpaceWithUnderscore } from '@dealstack/shared/lib/format/string';
import { Text } from '@mantine/core';

interface Props {
	item: TreeItem;
	onItemClick?: (item: TreeItem) => void;
	onSelectionChange?: (selectedIds: string[]) => void;
	onExpandChange?: (expandedIds: string[]) => void;
	nestingLevel?: number;
}

export const TreeItemComponent = ({
	item,
	onItemClick,
	onSelectionChange,
	onExpandChange,
	nestingLevel = 0,
}: Props) => {
	const handleClick = () => {
		onItemClick?.(item);

		if (item.isFolder) {
			onExpandChange?.([item.id]);
		} else {
			onSelectionChange?.([item.id]);
		}
	};

	const children =
		item.children?.length && (item.expanded || !item.isFolder) ? (
			<ChildrenContainer $nestingLevel={nestingLevel} $isFolder={item.isFolder}>
				{item.children.map((child) => (
					<ChildWrapper key={child.id}>
						<TreeItemComponent
							item={child}
							onItemClick={onItemClick}
							onSelectionChange={onSelectionChange}
							onExpandChange={onExpandChange}
							nestingLevel={nestingLevel + 1}
						/>
					</ChildWrapper>
				))}
			</ChildrenContainer>
		) : null;

	return (
		<>
			<TreeButton
				variant="subtle"
				onClick={handleClick}
				$isChecked={item.selected}
				icon={item.icon}
				data-testid={item.dataTestId ?? replaceSpaceWithUnderscore(item.name)}
			>
				<Text fz="md" fw={400} c="dark.9" miw="min-content" style={{ textWrap: 'nowrap' }}>
					{item.name}
				</Text>
			</TreeButton>
			{children}
		</>
	);
};
